import { BaseError, BaseErrorObject, resolveBaseErrorParams } from "./BaseError";

export enum LoginErrorType {
  InvalidEmail = "InvalidEmail",
  InvalidPassword = "InvalidPassword",
  InvalidTwoFACode = "InvalidTwoFACode",
  MissingTwoFA = "MissingTwoFA",
  /** User already has 2fa setup, but it was not provided in request */
  TwoFACodeRequired = "TwoFACodeRequired",
}

export class LoginError extends BaseError<LoginErrorType> {
  public name: "LoginError" = "LoginError" as const;
}

export const resolveLoginErrorParams = (err: any): BaseErrorObject<LoginErrorType> | null =>
  resolveBaseErrorParams<LoginErrorType>(err, LoginErrorType);
